<template>
  <div class="page">
    <IndexM v-if="isMobile" />
    <IndexP v-else />
  </div>
</template>

<script>
import IndexM from "./Index_m.vue";
import IndexP from "./Index_p.vue";
import { mapState } from "vuex";
export default {
  components: {
    IndexM,
    IndexP
  },
  computed: {
    ...mapState(["isMobile"])
  },

  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
}
</style>
